<template>
  <div class="sensor-graph">
    <highcharts
      class="chart"
      :options="chartOptions"
    />
    <div class="sg-overlay" />
  </div>
</template>

<script>
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'SensorGraph',
  mixins: [leadDetailMixin],
  computed: {
    tempFormat() {
      const { partnerSettings } = this.$store.state.admin;
      const {
        TEMP_UNIT = '°F',
      } = partnerSettings;
      return TEMP_UNIT;
    },
    chartOptions() {
      const {
        tempFormat,
      } = this;
      return {
        title: {
          text: 'Supply, Return Temperatures and Cooling Performance',
          style: {
            fontSize: 10,
            fontWeight: 600,
            fontFamily: 'Gilroy, sans-serif',
          },
        },
        chart: {
          type: 'line',
          zoomType: 'x',
          height: 250,
          spacingBottom: 15,
          spacingLeft: 10,
          spacingRight: 10,
          spacingTop: 15,
          animation: false,
        },
        credits: {
          enabled: false,
        },
        yAxis: [{
          labels: {
            format: `{value}${tempFormat}`,
            style: {
              fontSize: 8,
              fontFamily: 'Gilroy, sans-serif',
            },
          },
          title: {
            text: `Supply/Return(${tempFormat})`,
            style: {
              fontSize: 8,
              fontFamily: 'Gilroy, sans-serif',
            },
          },
          min: 32,
        }, {
          labels: {
            ormat: `{value}${tempFormat}`,
            style: {
              fontSize: 8,
              fontFamily: 'Gilroy, sans-serif',
            },
          },
          title: {
            text: `Delta(${tempFormat})`,
            style: {
              fontSize: 8,
              fontFamily: 'Gilroy, sans-serif',
            },
          },
          min: 0,
          max: 40,
          opposite: true,
        }],
        xAxis: [{
          categories: this.sensorGraphData.cycleDate,
          tickInterval: 7,
          labels: {
            style: {
              fontSize: 8,
              fontFamily: 'Gilroy, sans-serif',
            },
          },
        }],
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          itemStyle: {
            fontSize: 8,
            fontFamily: 'Gilroy, sans-serif',
          },
        },
        plotOptions: {
          series: {
            enableMouseTracking: false,
            label: {
              connectorAllowed: true,
            },
            connectNulls: true,
            animation: {
              duration: 0,
            },
            lineWidth: 1,
            marker: {
              radius: 2,
            },
          },
        },
        series: [{
          name: 'Supply Temp',
          color: '#6D94FF',
          data: tempFormat !== '°F' ? this.convertToCelsius(this.sensorGraphData.supplyTemp) : this.sensorGraphData.supplyTemp,
        }, {
          name: 'Return Temp',
          color: '#D8534D',
          data: tempFormat !== '°F' ? this.convertToCelsius(this.sensorGraphData.returnTemp) : this.sensorGraphData.returnTemp,
        }, {
          name: 'Cooling Performance',
          color: '#66D383',
          data: this.sensorGraphData.deltaTemp,
          yAxis: 1,
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 2000,
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
              },
            },
          }],
        },
      };
    },
  },
  methods: {
    convertToCelsius(value) {
      return Math.round((value - 32) * (5 / 9));
    },
  },
};
</script>

<style lang="scss">
.sensor-graph {
  border: 1px solid #EDF2FF;
  border-radius: 16px;
  margin: 20px 0;
  width: 100%;
  position: relative;
  box-shadow: 0 1px 10px 0 rgba(9, 15, 32, 0.1);
  .sg-overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
</style>
